export default {
  data() {
    return {
      _disabled: this.disabled
    }
  },
  methods: {
    onSetDisabled(disabled) {
      this._disabled = disabled;
      this.$forceUpdate();
    },
    getIsDisabled() {
      if (this.disabled === false) return false;

      return this.disabled || this._disabled;
    },
    getValue() {
      return this.model[this.modelAttribute || this.name];
    },
    onChange() {
      this.$emit('change', this.getValue());
    }
  }
}
